import React, { useEffect, useState } from "react";
import { useToaster } from "../../context/ToasterContext";
import TextInputComponent from "../../components/textinput";
import ButtonComponent from "../../components/button";
import { formatAmountInLocale } from "../../utils/global";

const PaymentOboScreen = ({ order_type, loading, shopDetails, currentOrderData, splitAmountToBePaid, getOrderStatusResult, setStep, createPaymentIntentApiCall, mountPaymentElements, setScreenName, oboName, setOboName, pageName }) => {
  const { toaster } = useToaster();

  const oboNameSubmit = (e) => {
    e.preventDefault();

    if(oboName === '' || oboName === null){
      toaster.error("Please enter name!");
    }
    else{
      setScreenName("payment");

      if(order_type === 'variable_price' || order_type === 'variable_self'){
        setStep(1);
      }
      else{
        setStep(2);

        if(pageName === 'stripe-payment' || pageName === 'adyen-payment' || pageName === 'airwallex-payment' || pageName === 'tyro-payment' || pageName === 'nets-payment'){
          createPaymentIntentApiCall(currentOrderData);
        }
        else if(pageName === 'square-payment'){
          mountPaymentElements();
        }
      }
    }
  };

  return (
    <>
      <div>
        {order_type !== 'variable_price' && order_type !== 'variable_self' &&
          <div className="text-center mb-3">
            <p className="text-color-amount-label">Amount left to be paid</p>
            {!loading && <h4 className="text-color-amount-heading">{shopDetails.currency_with_symbol}{formatAmountInLocale(shopDetails.user_currency,splitAmountToBePaid)}</h4>}
          </div>
        }
        {(order_type === 'variable_price' || order_type === 'variable_self') &&
          <div className="text-center mb-3">
            <p className="text-color-amount-label">Amount left to be paid</p>
            {!loading && <h4 className="text-color-amount-heading">{shopDetails.currency_with_symbol}{formatAmountInLocale(shopDetails.user_currency,getOrderStatusResult.amount_left)}</h4>}
          </div>
        }

        <div className="text-center mb-3">
          <p className="note">Enter the name of the person you're paying on behalf of</p>
        </div>

        <form id="obo-name-form" className="whiteCard mt-4" onSubmit={oboNameSubmit}>
          <div className="input-wrapper mb-0">
            <TextInputComponent
              label="Enter name"
              id="obo_name"
              value={oboName}
              type="text"
              onChange={(e) => {
                setOboName(e.target.value);
              }}
              size="lg"
              placeholder="E.g.: John Doe"
              disabled={loading}
            />

            <ButtonComponent
              type="submit"
              id="next_btn"
              className="btn btn-primary btn-pool-shadow btn-pool-full"
              label="Next"
              size="md"
              variant="primary"
            ></ButtonComponent>
          </div>
        </form>
      </div>
    </>
  );
};

export default PaymentOboScreen;
